import { Controller } from "@hotwired/stimulus";
import { gsap } from "gsap/all";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

const MOBILE_BREAKPOINT = 1024;

export default class extends Controller {
  static targets = ["picture"];

  connect() {
    this._setupCurtainEffect();
  }

  disconnect() {
    this.openTrigger?.kill();
    this.visibilityTrigger?.kill();
  }

  _getStackingIndex() {
    const allCurtainBlocks = document.querySelectorAll(
      '[data-controller~="curtain-picture"]'
    );
    return Array.from(allCurtainBlocks).indexOf(this.element) + 1;
  }

  _isFirstBlock() {
    return this._getStackingIndex() === 1;
  }

  _isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  _setupCurtainEffect() {
    if (!this.hasPictureTarget) return;

    const zIndex = this._getStackingIndex();
    const isFirst = this._isFirstBlock();
    const isMobile = this._isMobile();

    this.pictureTarget.style.position = "fixed";
    this.pictureTarget.style.top = "0";
    this.pictureTarget.style.left = "0";
    this.pictureTarget.style.width = "100%";
    this.pictureTarget.style.height = "100dvh";
    this.pictureTarget.style.zIndex = String(zIndex);

    gsap.set(this.pictureTarget, { clipPath: "inset(0% 0 0 0)" });

    if (!isFirst) {
      gsap.set(this.pictureTarget, { clipPath: "inset(100% 0 0 0)" });

      this.openTrigger = gsap.to(this.pictureTarget, {
        clipPath: "inset(0% 0 0 0)",
        ease: "none",
        scrollTrigger: {
          trigger: this.element,
          start: isMobile ? "top 80%" : "top bottom",
          end: "top top",
          scrub: true,
        },
      }).scrollTrigger;
    }

    this.visibilityTrigger = ScrollTrigger.create({
      trigger: this.element,
      start: "top bottom",
      end: "bottom top",
      onLeave: () => {
        this.pictureTarget.style.visibility = "hidden";
      },
      onEnterBack: () => {
        this.pictureTarget.style.visibility = "visible";
      },
      onLeaveBack: () => {
        this.pictureTarget.style.visibility = "hidden";
      },
      onEnter: () => {
        this.pictureTarget.style.visibility = "visible";
      },
    });
  }
}
